module.exports = __webpack_public_path__ + "img/a warm meal.64342ab6.png";